import { createSlice } from '@reduxjs/toolkit';
import type { EmailVerificationResponse } from 'api/models/TEmail';

export type EmailCaptureState = {
  isLoading: boolean;
  errors: null | [];
  email: string;
  data: EmailVerificationResponse;
};

export const initialState: EmailCaptureState = {
  isLoading: false,
  errors: null,
  email: '',
  data: {}
};

export const slice = createSlice({
  name: 'emailCapture',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.errors = payload;
    },
    setEmail: (state, { payload }) => {
      state.email = payload;
    }
  }
});

export const {
  setInitialState,
  setEmail,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectEmail = (state) => selectSlice(state).email;
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
